import React from 'react';

/** @deprecated DO NOT USE - superseded by `components/GraphVisualisation/RuleGraphProvider` */
const AttributeContext = React.createContext();

export default AttributeContext;
